import { input } from 'vue-strap'

// Preserve Vue Strap validation/events while putting associations on the real field.
export default {
    extends: input,
    inheritAttrs: false,
    mounted () { this.syncAccessibility() },
    updated () { this.syncAccessibility() },
    methods: {
        syncAccessibility () {
            const field = this.$refs.input
            if (!field) return
            const id = this.$attrs.id || 'tone-field-' + this._uid
            field.id = id
            Object.keys(this.$attrs).forEach(name => {
                if (/^(aria-|autocomplete$|inputmode$)/.test(name)) {
                    field.setAttribute(name, this.$attrs[name])
                }
            })
            const label = this.$el.querySelector('label')
            if (label) label.htmlFor = id
            if (!label && !field.hasAttribute('aria-label') && !field.hasAttribute('aria-labelledby')) {
                field.setAttribute('aria-label', this.label || this.placeholder || this.name || 'Text input')
            }
            const descriptions = (this.$attrs['aria-describedby'] || '').split(/\s+/).filter(Boolean)
            Array.prototype.forEach.call(this.$el.querySelectorAll('.help-block'), (help, index) => {
                help.id = id + '-help-' + index
                if (descriptions.indexOf(help.id) === -1) descriptions.push(help.id)
            })
            if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '))
            else field.removeAttribute('aria-describedby')
            field.setAttribute('aria-invalid', this.canValidate && this.valid === false ? 'true' : 'false')
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Input.js